import { render, staticRenderFns } from "./DashNegotiationList.vue?vue&type=template&id=70167ead&scoped=true&"
import script from "./DashNegotiationList.vue?vue&type=script&lang=js&"
export * from "./DashNegotiationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70167ead",
  null
  
)

export default component.exports